import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Trophy: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 570.01c-3.54 0-7.08-.72-10.45-2.16-28.53-11.86-169.55-81.09-169.55-288.38v-138.22h30v138.22c0 185.75 122.33 248.44 150 260.23 27.7-11.85 150-74.77 150-260.27v-138.17h30v138.17c0 207.07-141.03 276.52-169.54 288.42-3.38 1.44-6.92 2.17-10.46 2.17z' />
    <path d='m210 120h360v30h-360z' />
    <path d='m510 660h-240v-30h210c16.57 0 30 13.43 30 30z' />
    <path d='m375 555h30v95h-30z' />
    <path d='m600 180h90v30h-90z' />
    <path d='m660 195v58.04c0 30.32-12.93 55.94-38.42 76.16-9.12 7.23-18.57 12.76-26.9 16.88-2.09 12.58-4.74 24.53-7.88 35.83 12.04-4.27 33.4-13.32 53.42-29.2 32.57-25.82 49.78-60.29 49.78-99.67v-58.04z' />
    <path d='m90 180h90v30h-90z' />
    <path d='m120 195v58.04c0 30.32 12.93 55.94 38.42 76.16 9.12 7.23 18.57 12.76 26.9 16.88 2.09 12.58 4.74 24.53 7.88 35.83-12.04-4.27-33.4-13.32-53.42-29.2-32.57-25.82-49.78-60.29-49.78-99.67v-58.04z' />
  </IconBase>
));

Trophy.displayName = 'Trophy';

export default Trophy;
